import _ from 'lodash'

export const getDataSlice = (data, scrollValue, maxHorizontalItems, translateItemKeys) =>
  _(data)
    .slice(scrollValue, scrollValue + maxHorizontalItems)
    .map(translateItemKeys)
    .value()
